import React, { useState } from 'react';
import './NewTestimonio.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewTestimonio() {
    const [mensaje, setMensaje] = useState('');
    const [fotoPreview, setFotoPreview] = useState(null);
    const [nombre, setNombre] = useState('');
    const [testimonio, setTestimonio] = useState('');
    const [isFotoSelected, setIsFotoSelected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleFotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const previewURL = URL.createObjectURL(file);
            setFotoPreview(previewURL);
            setIsFotoSelected(true);
        }
    };

    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        
        const resetForm = () => {
            form.reset();
            setFotoPreview(null);
            setIsFotoSelected(false);
            setNombre('');
            setTestimonio('');
        };
        
        setMensaje('');

        if (!formData.get('nombre') || !formData.get('testimonio')) {
            toast.error('Por favor, complete todos los campos correctamente.');
            return;
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/testimoniosPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
                console.log(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span> Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Testimonio</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre del cliente (obligatorio)</legend>
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        required
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset id='descripcion'>
                                    <legend>Testimonio (obligatorio)</legend>
                                    <textarea
                                        id="testimonio"
                                        name="testimonio"
                                        required
                                        value={testimonio}
                                        onChange={(e) => setTestimonio(e.target.value)}
                                        placeholder="Escribe el testimonio del cliente"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Foto de perfil (opcional)</legend>
                                    <input
                                        type="file"
                                        id="foto"
                                        name="foto"
                                        accept="image/*"
                                        onChange={handleFotoChange}
                                    />
                                </fieldset>
                            </div>
                            
                            {isFotoSelected && (
                                <div className='previevCategori'>
                                    <img src={fotoPreview} alt="Vista previa" />
                                </div>
                            )}
                            
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}


